<avi-data-grid
    [config]="significanceGridConfig"
    [rows]="significantLog | logSignificanceReasons"
></avi-data-grid>
<ng-template
    #significanceFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        class="vs-log-significance__row"
        *ngIf="row.description"
        aviTitle="{{ row.description }}"
        vsLogPartialSelectionFilter
        [noSearchIcon]="true"
        property="significance"
        [value]="row.label"
        (onFilterAdd)="onFilterAdd.emit()"
    ></span>
    <span
        class="vs-log-significance__row"
        *ngIf="!row.description"
        vsLogPartialSelectionFilter
        property="significance"
        [noSearchIcon]="true"
        [value]="row.label"
        (onFilterAdd)="onFilterAdd.emit()"
    ></span>
</ng-template>
